import Text14 from '@sdk/components/ui/typography/Text14';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { Feature } from '@sdk/common/features';
import gettext from '@sdk/lang/gettext';
import { SubscriptionPlanNames } from '@sdk/account/types';

import PremiumGuardLabel from '@web/premiumGuard/PremiumGuardLabel';
import { useBreakAutomationOptions } from '@web/settings/components/schedule/Breaks/BreaksContent/breaksContent.hooks';
import {
  FullWidthRow,
  LabelPlacement,
} from '@web/settings/components/schedule/Breaks/BreaksContent/disabledBreakAutomationOption.styles';
import usePremiumGuard from '@web/premiumGuard/usePremiumGuard';

type Props = {
  label: string;
};

const DisabledBreakAutomationOption = ({ label }: Props) => {
  const { getRequiredPlan } = usePremiumGuard();
  const { showPremiumModal } = useBreakAutomationOptions();
  const requiredPlan = getRequiredPlan(Feature.automatedBreaks);
  let planLabel;
  if (requiredPlan === SubscriptionPlanNames.toastSlingPro) {
    planLabel = gettext('Pro');
  } else {
    planLabel = requiredPlan;
  }

  return (
    <FullWidthRow alignItems="center" justifyContent="space-between" onClick={showPremiumModal}>
      <Text14 themeColor={ThemeColorType.gray} opacity={0.5}>
        {label}
      </Text14>
      <LabelPlacement>
        <PremiumGuardLabel label={planLabel} useLabelForSelectBox />
      </LabelPlacement>
    </FullWidthRow>
  );
};

export default DisabledBreakAutomationOption;
